import Topup2c2pService from "../../service/Topup2c2pService";

export default function (states) {
    const loadUserProfile = function () {
        return new Promise((resolve, reject) => {
            Topup2c2pService.getProfile(states.query.token, states.query.appId, states.blobWebLanding, states.query.jwt).subscribe({
                next: (profile) => {
                    states.profile = profile
                    resolve(profile)
                },
                error: (err) => {
                    states.profile = null
                    reject(err)
                }
            })
        })
    }

    return {
        loadUserProfile
    }
}
